import {FlatListForLogGenericState} from '../../components/flats/FlatListForLogGenericState';
import {showLoaderAsync} from '../../helpers/loaders';
import {api} from '../../ApiFacade';
import {action, runInAction} from 'mobx';
import {FlatListDto, LogOverviewDtoGenericApiResponse} from '../../swagger';
import {showCommunicationError, showNotFoundToast} from '../../helpers/alerts';
import {AppRoutes, logOverviewLink} from '../../routing/AppRoutes';
import {mainState} from '../../AppMainState';
import {setTitle} from '../../routing/AppRouting';
import {redirectTo} from '../../routing/browserHistory';

export class LogOverviewViewState extends FlatListForLogGenericState {
    private flatsLoading: boolean = false;

    loadList(loadLast?: boolean): Promise<void> {
        if (this.flatsLoading) {
            return Promise.resolve();
        }

        this.flatsLoading = true;

        return showLoaderAsync(api().dashboards.apiDashboardLogOverviewGet(this.listParams))
            .then(res => {
                if (res.errors) {
                    redirectTo(AppRoutes.Settings);
                    showNotFoundToast();
                    return;
                }
                if (res.content?.items && res.content?.items.length > 0 && this.currentFlatId === undefined) {
                    this.loadFlat(loadLast ? res.content?.items[res.content?.items.length - 1] : res.content?.items[0]);
                }

                if (this.currentFlatId && this.listParams.logId) {
                    this.loadFlat({
                        flatId: this.currentFlatId,
                        logId: this.listParams.logId,
                    });
                }

                setTitle(res.content?.name);
                runInAction(() => {
                    this.log = res.content;
                    if (!this.currentFlatId) {
                        this.flat = undefined;
                    }
                    if (mainState.isDemoUser) {
                        mainState.isTourOpen = true;
                    }
                });

            }).catch(err => {
                showCommunicationError(err);
                redirectTo(AppRoutes.Settings);
            })
            .finally(() => this.flatsLoading = false);
    }

    refreshFlats(): Promise<void> {
        return api().dashboards.apiDashboardLogOverviewGet(this.listParams)
            .then((res: LogOverviewDtoGenericApiResponse) => {
                runInAction(() => {
                    if (!this.log) {
                        return;
                    }

                    this.log.graph = res.content?.graph;
                    // nie odświeżaj jak obecnego flata nie ma na liście
                    if (!this.pauseListRefresh &&
                        (!this.flat || (this.flat && res.content && res.content.items &&
                            res.content.items.findIndex(x => x.flatId === this.flat?.flatId) !== -1))) {
                        this.log.items = res.content?.items;
                    }
                });

            }).catch(err => showCommunicationError(err));
    }

    flatLoadUrlHandler(flat: FlatListDto) {
        if (!this.flat || !this.log) {
            return;
        }
        // eslint-disable-next-line no-restricted-globals
        if (!location.pathname.includes(this.flat.flatId!)) {
            // eslint-disable-next-line no-restricted-globals
            window.history.replaceState({}, 'Muscula', logOverviewLink(this.log.logId!, this.flat.flatId!));
        }
    }

    flatClickHandler(v: FlatListDto): void {
        this.loadFlat(v);
    }

    @action
    search(): void {
        this.listParams.page = 1;
        this.loadList(true);
    }

    delete(): void {
        super.deleteFlats();
    }
}
